export default __webpack_public_path__ + "static/media/NanumSquareEB.87e8b5f9.eot";